import { track } from '~/utils/tracking'

export type ContactClickEvent = 'click_phone' | 'click_viber' | 'click_voice'

export function classifyContactClick(target: Element | null): ContactClickEvent | null {
  if (!target) return null
  if (target.closest('.voice-order, [data-tracking="voice"]')) return 'click_voice'

  const href = target.closest('a[href]')?.getAttribute('href')?.trim().toLowerCase() ?? ''
  if (href.startsWith('tel:')) return 'click_phone'
  if (href.startsWith('viber:') || /^(https?:\/\/[^/]+)?\/go\/viber\/?(\?|$)/.test(href)) return 'click_viber'
  return null
}

let installed = false

/** One capture-phase listener covers every link on the site, including content pages. */
export function installContactClickTracking() {
  if (import.meta.server || installed) return
  installed = true
  document.addEventListener('click', (event) => {
    const name = classifyContactClick(event.target instanceof Element ? event.target : null)
    if (name) track(name)
  }, { capture: true })
}
